<template>
  <div class="container">
    <div class="hot_country">
      <div class="container">
        <h3 :style="{ fontSize: fontSize.h3 + 'em' }">熱搜國家</h3>
        <div class="item_group">
          <div
            class="item"
            v-for="(country, countryId) in countries"
            :key="countryId"
          >
            <router-link :to="`/${country.countryId}`" :title="country.country">
              <div class="pic">
                <img :src="country.flagFile" alt="國家國旗" />
              </div>
              <p :style="{ fontSize: fontSize.p + 'em' }">
                {{ country.country }}
              </p>
              <span class="circle"></span>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { defineComponent, reactive, inject } from "vue";
import { apiPopularCountry } from "@/api/api.js";

export default defineComponent({
  name: "HotCountry",
  setup() {
    let fontSize = inject("fontSize");
    const countries = reactive([]);
    apiPopularCountry()
      .then(function (res) {
        res.data.forEach((i) => {
          countries.push(i);
        });
      })
      .catch((err) => {
        console.log(err);
      });

    return {
      // value,
      // onSearch,
      countries,
      fontSize,
    };
  },
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.container {
  .hot_country {
    padding-bottom: 40px;
    @include md {
      padding-bottom: 20px;
    }
    .container {
      h3 {
        color: $main_color;
        margin-bottom: 15px;
        @include md {
          margin-bottom: 0px;
        }
      }
      .item_group {
        @include flex_between();
        width: 570px;
        margin: 0 auto;
        @include md {
          width: 450px;
        }
        @include sm {
          width: 100%;
        }
        @include xs {
          .pic {
            width: 90%;
          }
        }
        p {
          color: $black_color;
        }
      }
      .item {
        width: 99px;
        height: 100px;
        &:hover {
          border: 2px dashed $main_color;
          border-radius: 50%;
          @include lg {
            border: none;
          }
        }
        a {
          transform: translateY(18px);
        }
      }
      .pic {
        width: 64px;
        aspect-ratio: 16 / 9;
        img {
          object-fit: cover;
        }
      }
    }
  }
}
</style>
